import { useContext, useState } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';
import Namyoung1 from 'assets/Home/portfolio/namyoung1.avif'
import Namyoung2 from 'assets/Home/portfolio/namyoung2.avif'
import Namyoung4 from 'assets/Home/portfolio/namyoung4.avif'
import NamyoungSlide1 from 'assets/Home/portfolio/namyoungSlide1.avif';
import NamyoungSlide2 from 'assets/Home/portfolio/namyoungSlide2.avif';
import NamyoungSlide3 from 'assets/Home/portfolio/namyoungSlide3.avif';
import NamyoungSlide4 from 'assets/Home/portfolio/namyoungSlide4.avif';
import NamyoungSlide5 from 'assets/Home/portfolio/namyoungSlide5.avif';
import NamyoungSlide6 from 'assets/Home/portfolio/namyoungSlide6.avif';
import NamyoungSlide7 from 'assets/Home/portfolio/namyoungSlide7.avif';
import NamyoungSlide8 from 'assets/Home/portfolio/namyoungSlide8.avif';
import NamyoungSlide9 from 'assets/Home/portfolio/namyoungSlide9.avif';
import NamyoungSlide10 from 'assets/Home/portfolio/namyoungSlide10.avif';
import NamyoungSlide11 from 'assets/Home/portfolio/namyoungSlide11.avif';
import NamyoungSlide12 from 'assets/Home/portfolio/namyoungSlide12.avif';
import NamyoungSlide13 from 'assets/Home/portfolio/namyoungSlide13.avif';
import NamyoungSlide14 from 'assets/Home/portfolio/namyoungSlide14.avif';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import StackedScroll from './StackedScroll';

const Namyoung = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)
    const list: any = [NamyoungSlide1, NamyoungSlide2, NamyoungSlide3, NamyoungSlide4, NamyoungSlide5, NamyoungSlide6, NamyoungSlide7, NamyoungSlide8, NamyoungSlide9, NamyoungSlide10, NamyoungSlide11, NamyoungSlide12, NamyoungSlide13, NamyoungSlide14];

    const [active, setActive] = useState<'a' | 'b'>('a');

    const cards = [
        {
            key: 'a',
            img: Namyoung1,
            align: 'top-left',
            title: '3D',
            desc: 'real-time 3D creation tool++',
            footer: 'REALITY',
            wrapperClass:
                'top-0 left-0 absolute mobile:relative mobile:mb-3 rounded-2xl w-fit laptop:w-2/3 mobile:w-full h-fit cursor-pointer',
        },
        {
            key: 'b',
            img: Namyoung2,
            align: 'bottom-right',
            title: 'AR',
            desc: 'Augmented Reality++',
            footer: 'VIRTUAL',
            wrapperClass:
                'right-0 bottom-0 absolute mobile:relative rounded-2xl w-fit laptop:w-2/3 mobile:w-full h-fit cursor-pointer',
        },
    ];

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    VR 안전교육 기술력
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    언리얼엔진5로 구성된 가상환경에서 실제 산업현장과{!isTablet && <br />}
                    상호작용을 통한 현장의 모습을 구현합니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    게임, 영화, VR 등 여러 분야에서 사용되는 가장 강력한 실시간 3D 제작도구인{!isTablet && <br />}
                    언리얼엔진5를 기반으로 실제현장의 모습을 AR로 재현함으로써 생동감있는{!isTablet && <br />}
                    경험을 통해 참여형 안전교육 생태계를 제공합니다.
                </motion.h4>

                <div className="relative w-full h-[700px] laptop:h-[450px] mobile:h-full tablet:h-[350px] select-none">
                    {cards.map((card) => {
                        const isActive = active === card.key;

                        return (
                            <motion.div
                                key={card.key}
                                onClick={() => setActive(card.key as 'a' | 'b')}
                                animate={{ zIndex: isActive ? 20 : 10 }}
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                transition={{ duration: 0.45, ease: 'easeInOut' }}
                                className={card.wrapperClass}
                            >
                                <img
                                    src={card.img}
                                    className="object-contain"
                                    alt=""
                                />

                                {/* 상단 텍스트 */}
                                <motion.div
                                    animate={{ opacity: isActive ? 1 : 0.4 }}
                                    transition={{ duration: 0.3 }}
                                    className="top-0 left-0 z-20 absolute laptop:p-4 px-[52px] py-10 text-white"
                                >
                                    <h2 className="font-semibold text-[140px] laptop:text-44 leading-none laptop:leading-[1]">
                                        {card.title}
                                    </h2>
                                    <p className="opacity-80 laptop:text-lg text-3xl leading-[0]">
                                        {card.desc}
                                    </p>
                                </motion.div>

                                {/* 하단 텍스트 */}
                                <motion.div
                                    animate={{ opacity: isActive ? 1 : 0.4 }}
                                    transition={{ duration: 0.3 }}
                                    className="bottom-0 left-0 z-20 absolute laptop:p-4 px-[64px] py-10 mobile:py-2 w-full text-white"
                                >
                                    <h2 className="flex justify-between w-full text-[100px] laptop:text-32 leading-none">
                                        {Array.from(card.footer).map((char, i) => (
                                            <span key={i} className="block">
                                                {char}
                                            </span>
                                        ))}
                                    </h2>
                                </motion.div>
                            </motion.div>
                        );
                    })}
                </div>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    가상현실 환경 디자인
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    실제현장의 이미지를 기반으로 가상현실 세상을 구현하고{!isTablet && <br />}
                    3D 물리법칙을 기반으로 상호작용 공간을 제공합니다
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    고객이 제공한 이미지 또는 자체제작을 통하여 실제현장과 유사한 공간을{!isTablet && <br />}
                    제작하여 가상현실과 실제공간에 대한 간격을 최소화합니다.
                </motion.h4>

                <StackedScroll />
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    인터랙션 및 UI환경 제공
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    회원가입 및 회원정보를 저장할 수 있는 데이터저장부터{!isTablet && <br />}
                    상호작용을 통한 안전교육 진행 환경을 패킷 제공합니다{!isTablet && <br />}
                    게임을 플레이하는 것처럼 간단하게 접근해보세요
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    기본적인 UI부터 데이터저장까지 실행 파일 하나로 관리하고,{!isTablet && <br />}
                    간단한 VR 사용방법만 익히시면 모든 솔루션을 체험이 가능합니다.
                </motion.h4>

                <Swiper
                    slidesPerView={1}
                    modules={[Pagination]}
                    pagination={{
                        clickable: true
                    }}
                >
                    {
                        list.map((item: any, idx: number) => (
                            <SwiperSlide key={idx}>
                                <motion.img
                                    className='rounded-3xl'
                                    alt={item}
                                    src={item}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY}
                                >
                                </motion.img>
                            </SwiperSlide>
                        ))}
                </Swiper>
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    고객 맞춤형 제작
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    프로젝트에 알맞는 솔루션을 바탕으로 탄탄한 스토리보드를 거쳐{!isTablet && <br />}
                    3D 모델링 및 상호작용 제작으로 맞춤형 가상현실을 제공합니다
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    사용자 관점에서 제작되는 기획을 바탕으로 각 분야의 전문가를 통해 프로젝트의{!isTablet && <br />}
                    전반적인 청사진을 확인할 수 있습니다.
                </motion.h4>

                <motion.img
                    src={Namyoung4}
                    alt="Namyoung4"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Namyoung
